import React from "react";
import { useTranslation } from "react-i18next";

import { Divider, useMediaQuery, useTheme } from "@mui/material";
import { FundDetails } from "@rentablo/api/apiv1";
import { useRecommendationDetails } from "../../RecommendationDetailsProvider";
import { BarChartBlock } from "./BarChartBlock";
import { ProductInfoTable } from "./ProductInfoTable";
import { TwoColLayout } from "./TwoColLayout";
import { LegendBlock } from "./LegendBlock";

const getData = (
  logos: {
    originalFund?: React.ReactNode;
    recommendation?: React.ReactNode;
  },
  investmentFundDetails?: FundDetails,
  recommendationFundDetails?: FundDetails
) => {
  const data = [];
  if (investmentFundDetails?.costStatistics?.allInFee) {
    data.push({
      name: investmentFundDetails?.name,
      cost: investmentFundDetails?.costStatistics?.allInFee,
      logo: logos.originalFund,
    });
  }

  if (recommendationFundDetails?.costStatistics?.allInFee) {
    data.push({
      name: recommendationFundDetails?.name,
      cost: recommendationFundDetails?.costStatistics?.allInFee,
      logo: logos.recommendation,
    });
  }

  return data;
};

export const FeeCostSection = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDownSm = useMediaQuery(theme.breakpoints.down("sm"));
  const { logos, names, investmentFundDetails, fundDetails } =
    useRecommendationDetails();
  const data = getData(logos, investmentFundDetails, fundDetails);

  if (data.length === 0) {
    return null;
  }

  return (
    <>
      <TwoColLayout
        component1={
          <>
            <BarChartBlock
              investmentName={names.investment}
              recommendationName={names.recommendation}
              investmentValue={
                investmentFundDetails?.costStatistics?.allInFee ?? 0
              }
              recommendationValue={fundDetails?.costStatistics?.allInFee ?? 0}
              title="recommender.compareView.fees.feeTitle"
              chartLabel="recommender.compareView.fees.feeLabel"
              titleTooltip="recommender.compareView.fees.feeTooltip"
              showSmaller
            />
            {isDownSm && (
              <LegendBlock
                ogFundName={names.investment}
                recommendationName={names.recommendation}
                margin={theme.spacing(6, 0, 0, 0)}
              />
            )}
          </>
        }
        component2={<ProductInfoTable data={data} />}
        title={t("recommender.compareView.fees.title")}
      />
      {!isDownSm && (
        <LegendBlock
          ogFundName={names.investment}
          recommendationName={names.recommendation}
          margin={theme.spacing(6, 0, 0, 0)}
        />
      )}
      <Divider sx={{ mt: 9, mb: 8 }} />
    </>
  );
};
